<div class="panel-body no-padding">
  <h4>
    <b>Justificativa do novo ajuste</b>
  </h4>
  <div>
    <trumbowyg [initialContent]="justContIni" [options]="options1" [update]="update$"
      (savedContent)="versaoPlano.justificativa=$event"></trumbowyg>
  </div>
  <br>
  <h4>
    <b>Anexo da justificativa </b>
    <button class="btn btn-primary btn-sm  pull-center" (click)="openModalUpload()" *ngIf="!dataUpload">
      Anexar arquivo</button>
  </h4>
  <div class="col-md-12">
    <div class="form-group">
      
      <table class="table" *ngIf="dataUpload">
        <thead>
          <tr>
            <th width="50%">Nome arquivo</th>
            <th>Tamanho</th>
            <th class="text-center">Remover</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>{{ dataUpload.originalname }}</strong>
            </td>
            <td nowrap>{{ dataUpload.size/1024/1024 | number:'.2' }} MB</td>
            <td class="text-center">
              <span class="cursor">
                <i class="glyphicon glyphicon-remove" (click)="removeFileProposta()"></i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  <hr>

  <div class="timeline-footer">
    <a class="btn btn-success btn-sm pull-right" (click)="solicitarMudanca()">Solicitar mudança</a>
  </div>

</div>

<!--*******************************UPLOAD*****************************-->
<p-dialog [(visible)]="openModalViewUpload" width="700" showEffect="fade" [modal]="true">
  <div class="col-sm-12">
    <h3>Upload de arquivos.</h3>
    <button type="button" class="btn btn-success  btn-sm" (click)="adicionarArquivo()">
      <i class="fa fa-fw fa-save"></i> Salvar
    </button>
    <hr>
  </div>
  <div class="col-sm-12">
    <app-upload-service></app-upload-service>
    <hr>
  </div>
</p-dialog>
<!--******************************************************************************-->